export const RESET = 'EXCMUSERDATASALESOPPORTUNITY_UPDATE_RESET'
export const SET_ERROR = 'EXCMUSERDATASALESOPPORTUNITY_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMUSERDATASALESOPPORTUNITY_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMUSERDATASALESOPPORTUNITY_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMUSERDATASALESOPPORTUNITY_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMUSERDATASALESOPPORTUNITY_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMUSERDATASALESOPPORTUNITY_UPDATE_UPDATE_RETRIEVED'
